import { render } from "./InvoiceDashboard.vue?vue&type=template&id=01ff6b8a&scoped=true"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js"

import "./InvoiceDashboard.vue?vue&type=style&index=0&id=01ff6b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ff6b8a"]])

export default __exports__